<template>
  <div>
    <canvas ref="canvas">
      <p class="text-center text-muted fs-17">No se pudo cargar el gráfico</p>
    </canvas>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs'
// import { reactiveProp } from 'vue-chartjs/src/mixins'

export default {
  name: 'LineChart',
  extends: Line,
  // mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      required: true
    },
    chartOptions: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions)
  },
  watch: {
    chartData: {
      handler(newData) {
        this.renderChart(newData, this.chartOptions)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
canvas {
  width: 100% !important;
  height: 300px !important;
}
</style>
